import React, { FC, useState } from 'react';
import { useStore } from '@/app/providers/StoreProvider';
import { observer } from 'mobx-react-lite';
import { Modal } from 'antd';
import { handleInvite } from '@/shared/utils/referralLink';

import ImgProfile from '@/shared/pictures/profile_icon.png';
import ImgHudPuck from '@/shared/pictures/hud_puck.png';
import ImgHudEnergy from '@/shared/pictures/hud_energy.png';
import ImgHudAdd from '@/shared/pictures/hud_add.svg';
import ImgModalInvite from '@/shared/pictures/invite.png';
import ImgClose from '@/shared/pictures/close.svg';
import { BonusInfo } from '@/entities/team/ui/BonusInfo';



export const Hud:FC = observer(() => {

    const {userStore,teamStore} = useStore();
    const {user,gameInfo,referralLink} = userStore;

    const {myTeam} = teamStore;

    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div className='hud'>
                <div className='profile_avatar profile_avatar-midi'>
                    {user.photoUrl
                    ?<img src={user.photoUrl} alt="photo" />
                    :<img src={ImgProfile} alt="photo" />
                    }

                </div>
                <div className='hud-score'>
                    <div className='hud-score_item'>
                        <div className='hud-score_icon'>
                            <img src={ImgHudPuck} alt="puck" />
                        </div>
                        <div className='hud-score_value'>{gameInfo.user.score}</div>
                    </div>
                    <div className='hud-score_item'>
                        <div className='hud-score_icon'>
                            {myTeam
                                ?<BonusInfo/>
                                :<img src={ImgHudEnergy} alt="energy" style={{maxWidth:24}}/>
                            }
                        </div>
                        <div className='hud-score_value'>{gameInfo.user.energy}</div>
                    </div>
                    <img src={ImgHudAdd} alt="add" onClick={()=>setIsModalOpen(true)}/>
                </div>
            </div>
            <Modal
              open={isModalOpen}
              footer={null}
              closeIcon={<img src={ImgClose} onClick={()=>setIsModalOpen(false)}/>}
            >
              <div className='modal'>
                <img src={ImgModalInvite} className='modal_image' alt="img" />
                <p className='modal_text'>Пригласи друзей и получи <br/><span className='modal_text-red'>+3</span> удара за каждого</p>
                <button type='button' className='modal_button' onClick={()=>handleInvite(referralLink,'Мне нужна твоя помощь, участвую в рейтинге приложения Александра Овечкина. Чем выше рейтинг, тем выше шанс получать подарки. Присоединяйся тоже, давай соревноваться вместе.')}>Пригласить</button>
              </div>
            </Modal>
        </>
    );
});
